import {useState} from "react";
import {TrashIcon} from "@heroicons/react/20/solid";
import {classNames} from "../../utils/misc";


export function DeleteButton ({onDelete, label, iconOnly, confirmPrompt, classNameIn}) {

    const [open, setOpen] = useState(false)

    function handleDelete() {
        onDelete()
        setOpen(false)
    }

    return (
        <>

            {open && <div className="bg-white border border-red-300 rounded-lg shadow-lg p-3 min-w-max">
                <div className="text-red-700 text-sm font-medium mb-2">
                    {confirmPrompt && <span>{confirmPrompt}</span>}
                    {!confirmPrompt && <span>Are you sure you want to delete?</span>}
                </div>
                <div className="flex gap-2 justify-end">
                    <button type="button" className="inline-flex justify-center rounded-md border border-transparent bg-red-600 px-3 py-1.5 text-sm font-medium text-white shadow-sm hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
                                          onClick={handleDelete}>Yes</button>
                    <button type="button"
                        className="inline-flex justify-center rounded-md border border-gray-300 bg-white px-3 py-1.5 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                        onClick={() => setOpen(false)}>Cancel</button>
                </div>
            </div>}

            {!open && <button
            type="button"
            className={classNames("text-red-700 inline-flex py-2 " + classNameIn)}
            onClick={() => setOpen(true)}>
                <TrashIcon className="h-5 w-5" /> {!iconOnly && <>{label || "Delete"}</>}
            </button>}

        </>
    )

}


export function DeleteImmediatelyButton ({onDelete, label, iconOnly, classNameIn}) {

    function handleDelete() {
        onDelete()
    }

    return (
        <>
            <button
                type="button"
                className={classNames("text-red-700 inline-flex py-2 " + classNameIn)}
                onClick={handleDelete}>
                <TrashIcon className="h-5 w-5" /> {!iconOnly && <>{label || "Delete"}</>}
            </button>
        </>
    )

}

